const charactersLimit = 11;

module.exports = function () {
    return function (input) {
        if (!input || input.length > charactersLimit) {
            return 'Hello';
        }

        return `Hi, ${input}`;
    };
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-username-limiter.js